var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 44,
    viewBox: "0 0 116 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.543 38.2958L100.841 38.3185L93.5935 23.6061L86.543 38.2958Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2456 43.2226L93.4358 0.816231H94.2291L115.419 43.2226H106.807L103.578 36.5513C100.276 29.2854 96.9743 22.0193 93.6726 14.7533C89.401 24.2431 85.1294 33.7327 80.8579 43.2226H72.2456Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.6222 8.00622H67.6702V43.2603H59.6642V8.00622H47.6553V0.816231H79.6222V8.00622Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1802 43.2603H44.3768V0.816231H36.1802V43.2603Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3264 36.0744C21.0149 36.0744 21.6649 35.9113 22.2771 35.5845C22.8885 35.2581 23.4247 34.8157 23.8837 34.2581C24.3425 33.7013 24.7057 33.0859 24.9738 32.4129C25.241 31.7408 25.3753 31.0577 25.3753 30.3659C25.3753 28.9439 24.8491 27.752 23.7975 26.7905C22.7453 25.8301 21.3017 25.349 19.4659 25.349H8.96672V36.0744H20.3264ZM8.96672 18.1987H18.8348C19.6382 18.1987 20.3355 18.0447 20.929 17.7346C21.5215 17.4256 22.019 17.0194 22.4207 16.5165C22.8222 16.014 23.1278 15.4437 23.3387 14.8056C23.5483 14.1676 23.6542 13.5397 23.6542 12.9207C23.6542 12.3027 23.5395 11.7035 23.31 11.1231C23.0804 10.5429 22.7737 10.0404 22.3919 9.61498C22.0093 9.18972 21.56 8.84205 21.0437 8.57152C20.5272 8.3013 19.9821 8.16529 19.4086 8.16529H8.96672V18.1987ZM31.6864 12.7539C31.6864 13.6027 31.5141 14.5082 31.1701 15.4723C30.8258 16.4365 30.357 17.3239 29.7643 18.1331C29.1708 18.9421 28.4536 19.6268 27.6128 20.1855C26.7712 20.7448 25.8531 21.0441 24.859 21.082C25.8916 21.1593 26.9144 21.4567 27.9283 21.9739C28.9414 22.491 29.8504 23.1913 30.6534 24.0732C31.4569 24.9555 32.1166 25.9715 32.6329 27.1212C33.1492 28.2719 33.4074 29.499 33.4074 30.8018C33.4074 33.1029 33.0632 35.0481 32.3746 36.6395C31.6864 38.2306 30.7486 39.5155 29.5635 40.4929C28.3775 41.4715 26.9908 42.1707 25.4041 42.5924C23.8164 43.0139 22.1241 43.2248 20.3264 43.2248H0.93457V1.0148H19.4086C21.0911 1.0148 22.6789 1.17882 24.1705 1.50672C25.662 1.83476 26.9621 2.43229 28.0718 3.29898C29.1808 4.16658 30.0601 5.36222 30.7111 6.88486C31.361 8.4075 31.6864 10.3647 31.6864 12.7539Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.adf987b478a6d2b62f03f1930aa8585a.svg";
export { ForwardRef as ReactComponent };